import type { MouseEventHandler } from 'react';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { Button as ButtonComponent } from '@elfsight/widget-ui';
import {
  getInvertedColor,
  openWindowByLink,
  useIsMobile
} from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { getStyleConfig } from '../../../constants/style-config';
import { StopDisplayTriggerTypes, useBarState } from '../../bar-state-provider';

export const Button = () => {
  const {
    buttonLink,
    buttonText,
    buttonStyle,
    buttonRadius,
    buttonColor,
    barSize,
    barSizeMobile,
    editMode
  } = useSettings();

  const isMobile = useIsMobile();
  const { stopDisplayTrigger } = useBarState();

  const buttonSizeStyles =
    getStyleConfig(isMobile).button[isMobile ? barSizeMobile : barSize];

  const clickHandler: MouseEventHandler = (e) => {
    stopDisplayTrigger(StopDisplayTriggerTypes.ACTIONELEMENT);
    if (buttonLink.value) {
      openWindowByLink(e, {
        ...buttonLink,
        target: editMode ? '_blank' : buttonLink.target
      });
    }
  };

  return (
    <ButtonComponent
      onClick={clickHandler}
      font={buttonSizeStyles.font as TextStyleValue}
      horizontalPadding={buttonSizeStyles?.horizontalPadding}
      verticalPadding={buttonSizeStyles?.verticalPadding}
      mode={buttonStyle === 'outline' ? buttonStyle : 'contain'}
      text={buttonText}
      borderRadius={buttonRadius}
      color={buttonColor}
      fontColor={getInvertedColor(buttonColor, ['#fff', '#000'])}
    />
  );
};
